import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortfolioComponent implements OnInit {
  @ViewChild('all') all: ElementRef;

  portfolio = [
    {
      name: 'Ecommerce',
      img: 'assets/img/portfolio/ecommerce.jpg',
      class: 'filter-app',
      web: 'https://ecommerce-angular-aba12.web.app/',
      github: 'https://github.com/diegopagini/Ecommerce_Angular',
    },
    {
      name: 'Teslo-Shop',
      img: 'assets/img/portfolio/teslo-shop.jpg',
      class: 'filter-card',
      web: 'https://tesloshopnext.herokuapp.com/',
      github: 'https://github.com/diegopagini/Teslo-Shop_NextJs',
    },
    {
      name: 'React Issues',
      img: 'assets/img/portfolio/react-query.jpg',
      class: 'filter-card',
      web: 'https://query-issues-react.vercel.app/',
      github: 'https://github.com/diegopagini/Query-Issues_React',
    },
    {
      name: 'Maps-App',
      img: 'assets/img/portfolio/maps-react.jpg',
      class: 'filter-card',
      web: 'https://main--neon-longma-6e7a44.netlify.app/',
      github: 'https://github.com/diegopagini/Maps-App_React',
    },
    {
      name: 'DevFinder',
      img: 'assets/img/portfolio/devfinder.jpg',
      class: 'filter-app',
      web: 'https://devfinder-github.web.app/',
      github: 'https://github.com/diegopagini/Devfinder-Github_Angular',
    },
    {
      name: 'Rock-Paper-Scissors',
      img: 'assets/img/portfolio/rps.jpg',
      class: 'filter-app',
      web: 'https://rock-paper-scissors-angular.web.app/',
      github: 'https://github.com/diegopagini/Rock-Paper-Scissors_Angular',
    },
    {
      name: 'Empleados',
      img: 'assets/img/portfolio/empleados.jpg',
      class: 'filter-app',
      web: 'https://angular-employees-app.web.app/',
      github: 'https://github.com/diegopagini/Employees-app_Angular',
    },
    {
      name: 'Credit Card',
      img: 'assets/img/portfolio/creditcard.jpg',
      class: 'filter-app',
      web: 'https://credit-card-6a2ef.web.app/',
      github: 'https://github.com/diegopagini/Credits-Cards_Angular',
    },
    {
      name: 'Shop List',
      img: 'assets/img/portfolio/mercado.jpg',
      class: 'filter-app',
      web: 'https://lista-mercado-ionic.web.app/',
      github: 'https://github.com/diegopagini/Shop-List_Ionic',
    },
    {
      name: 'Clima',
      img: 'assets/img/portfolio/clima.jpg',
      class: 'filter-app',
      web: 'https://weather-app-angular-62b9e.web.app/',
      github: 'https://github.com/diegopagini/Weather-app_Angular',
    },
    {
      name: 'Diplomas',
      img: 'assets/img/portfolio/diplomas.jpg',
      class: 'filter-app',
      web: 'https://diplomas-79a7c.web.app/',
      github: 'https://github.com/diegopagini/Displomas-Container_Angular',
    },
    {
      name: 'Fitness',
      img: 'assets/img/portfolio/fitness.jpg',
      class: 'filter-app',
      web: 'https://fitness-tracker-1f49d.web.app/',
      github: 'https://github.com/diegopagini/Fitness-Tracker_Angular',
    },
    {
      name: 'Games',
      img: 'assets/img/portfolio/games.jpg',
      class: 'filter-app',
      web: 'https://free-games-angular.web.app/',
      github: 'https://github.com/diegopagini/Free-Games_Angular',
    },
    {
      name: 'Presupuesto',
      img: 'assets/img/portfolio/presupuesto.jpg',
      class: 'filter-app',
      web: 'https://bugdet-ngrx.web.app',
      github: 'https://github.com/diegopagini/Budget-App_Angular',
    },
    {
      name: 'Crypto',
      img: 'assets/img/portfolio/crypto.jpg',
      class: 'filter-app',
      web: 'https://crypto-ngrx.web.app',
      github: 'https://github.com/diegopagini/Crypto_Angular',
    },
    {
      name: 'Pokemon',
      img: 'assets/img/portfolio/pokemon.jpg',
      class: 'filter-app',
      web: 'https://pokemon-angular-578e9.web.app',
      github: 'https://github.com/diegopagini/Pokemon_Angular',
    },
    {
      name: 'Movies',
      img: 'assets/img/portfolio/movies.jpg',
      class: 'filter-app',
      web: 'https://movies-angular-bb273.web.app/',
      github: 'https://github.com/diegopagini/Movies_Agular',
    },
    {
      name: 'Diario',
      img: 'assets/img/portfolio/diario.jpg',
      class: 'filter-card',
      web: 'https://journalapp-react-f6204.web.app/',
      github: 'https://github.com/diegopagini/Journal-App_React',
    },
    {
      name: 'Citas',
      img: 'assets/img/portfolio/citas.jpg',
      class: 'filter-app',
      web: 'https://appointments-ngrx.web.app',
      github: 'https://github.com/diegopagini/Appointments_Angular',
    },
    {
      name: 'Recetas',
      img: 'assets/img/portfolio/recetas.jpg',
      class: 'filter-app',
      web: 'https://recetas-online-6e495.web.app/',
      github: 'https://github.com/diegopagini/Recetas-App_Angular',
    },
    {
      name: 'Lol',
      img: 'assets/img/portfolio/lol.jpg',
      class: 'filter-app',
      web: 'https://lol-characters-8a360.web.app',
      github: 'https://github.com/diegopagini/LoL-Characters_Angular',
    },
    {
      name: 'Iglesia Next',
      img: 'assets/img/portfolio/next.jpg',
      class: 'filter-app',
      web: 'https://iglesia-next.web.app/',
      github: 'https://github.com/diegopagini/Iglesia-Next_Angular',
    },
    {
      name: 'Heroes',
      img: 'assets/img/portfolio/heroes.jpg',
      class: 'filter-card',
      web: 'https://heroesapp-react.web.app',
      github: 'https://github.com/diegopagini/Heroes-SPA_React',
    },
    {
      name: 'Gifts',
      img: 'assets/img/portfolio/gifts.jpg',
      class: 'filter-card',
      web: 'https://diegopagini.github.io/Gif-App_React/',
      github: 'https://github.com/diegopagini/Gif-App_React',
    },
    {
      name: 'Pokemon',
      img: 'assets/img/portfolio/pokemon-next.png',
      class: 'filter-card',
      web: 'https://pokemon-static-next-three.vercel.app/',
      github: 'https://github.com/diegopagini/Pokemon-Static_NextJs',
    },
    {
      name: 'Cargar Imagenes',
      img: 'assets/img/portfolio/fileupload.jpg',
      class: 'filter-app',
      web: 'https://fileupload-51ee0.web.app/',
      github: 'https://github.com/diegopagini/Fileupload_Angular',
    },
    {
      name: 'Juegos',
      img: 'assets/img/portfolio/juegos.jpg',
      class: 'filter-app',
      web: 'https://random-apps-abbf2.web.app/',
      github: 'https://github.com/diegopagini/Random-Apps_Angular',
    },
    {
      name: 'Peliculas',
      img: 'assets/img/portfolio/peliculas.jpg',
      class: 'filter-app',
      web: 'https://films-app-430e1.web.app/',
      github: 'https://github.com/diegopagini/Films-App_Angular',
    },
    {
      name: 'Rick and Morty',
      img: 'assets/img/portfolio/rym.jpg',
      class: 'filter-app',
      web: 'https://rick-and-morty-cecb9.web.app/',
      github: 'https://github.com/diegopagini/R-M_Angular',
    },
    {
      name: 'Tareas',
      img: 'assets/img/portfolio/tareas.jpg',
      class: 'filter-app',
      web: 'https://introduccion-ngrx.web.app/',
      github: 'https://github.com/diegopagini/Tareas-NgRx_Angular',
    },
    {
      name: 'Portfolio',
      img: 'assets/img/portfolio/portfolio.jpg',
      class: 'filter-app',
      web: 'https://portfolio-angular-fe6d0.web.app',
      github: 'https://github.com/diegopagini/Portfolio-Base_Angular',
    },
    {
      name: 'Gentleman Programing',
      img: 'assets/img/portfolio/gentleman.jpg',
      class: 'filter-app',
      web: 'https://gentlemanapp.web.app/',
      github: 'https://github.com/diegopagini/Youtube-App_Angular',
    },
    {
      name: 'Kanban',
      img: 'assets/img/portfolio/kanban.jpg',
      class: 'filter-app',
      web: 'https://angular-kanban-c9772.web.app',
      github: 'https://github.com/diegopagini/Kanban-Board_Angular',
    },
    {
      name: 'CRUD',
      img: 'assets/img/portfolio/crud.jpg',
      class: 'filter-app',
      web: 'https://crud-heroes-921a6.web.app/',
      github: 'https://github.com/diegopagini/CRUD-Heroes_Angular',
    },
    {
      name: 'Batabit',
      img: 'assets/img/portfolio/batabit.jpg',
      class: 'filter-app',
      web: 'https://batabit-7a4f0.web.app/',
      github: 'https://github.com/diegopagini/Bata-Bit_Angular',
    },
  ];

  ngOnInit(): void {
    this.triggerAll();
  }

  private triggerAll(): void {
    this.all.nativeElement.click();
    this.all.nativeElement.classList.add('filter-active');
  }
}
